// extracted by mini-css-extract-plugin
export default {"writtenFieldset":"_WrittenOralnput_writtenFieldset__am1Lq","oralBlock":"_WrittenOralnput_oralBlock__ASHV7"};